import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import Button from "@mui/material/Button";
import MDialog from "components/Shared/MDialog.tsx";
import { getTabbedHistoryTable } from "components/Homeowner/History/DataFormatters";
import { getNextNotification } from 'requests/schedulingAssistant';
import { updateCallDueDate } from "requests/contactEfforts";
import EditNotificationDueDateDialog from "./EditNotificationDueDateDialog.tsx";

const NotificationStep = props => {
  const [fetchingNotificationLog, setFetchingNotificationLog] = useState(false);  
  const [notificationLog, setNotificationLog] = useState([]);
  const [notificationOverdue, setNotificationOverdue] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    setFetchingNotificationLog(true);    
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 10000); // Refreshing call log every 10 seconds to pick up on events from PNX

    return () => {
      mounted.current = false;
      clearInterval(interval);
    };
  }, []);

  let fetchNotifications = () => {
    getNextNotification({
      ControlNumber: props.controlNumber
    }, (resp) => {
      setNotificationLog([resp]);
      setNotificationOverdue(Date.parse(resp.nextNotificationDate) <= Date.now());      
      setFetchingNotificationLog(false);      
    }, () => setFetchingNotificationLog(false), mounted);
  };

  let onEditDueDateSave = (data) => {
    updateCallDueDate({
      ControlIdNumber: props.controlNumber,
      CurrentDueDate: notificationLog[0]?.nextNotificationDate,
      NewDueDate: data.newDueDate
    }, () => setShowEditDialog(false), () => setShowEditDialog(false), mounted);
  };

  const colDefs = [
    { name: "Next Notification", dataSource: "nextNotificationName", style: { width: "200px" } },
    { name: "Next Notification Due Date", dataSource: "nextNotificationDateFormatted", style: 
      { width: "350px", color: notificationOverdue ? 'red' : ''} 
    },
    { name: "Previous Notification", dataSource: "previousNotificationName", style: { width: "200px" } },
    { name: "Previous Notification Date", dataSource: "previousNotificationDateFormatted", style: { width: "350px" } },
  ];  

  if(fetchingNotificationLog){
    return <MSpinner />;
  }

  return (
    <>
      <MDialog
        id="add-edit-notification-due-date-dialog"
        className="add-edit-notification-due-date-dialog mgridform-flat"
        title="Edit Call Due Date"
        visible={showEditDialog}
        focusOnMount={false}
        width={550}
      >
        {fetchingNotificationLog 
          ? <MSpinner />
          : <EditNotificationDueDateDialog
              data={{
                currentDueDate: notificationLog[0]?.nextNotificationDateFormatted,
                newDueDate: ""
              }}
              onCancel={() => setShowEditDialog(false)}
              onSave={onEditDueDateSave}
            />}
      </MDialog>   
      <div className="notification-due-date-buttons">
        <div className="notification-due-date-button">
          <Button className="history-action-button" onClick={() => setShowEditDialog(true)} disabled={!notificationLog[0]?.nextNotificationDateFormatted}>
            Edit
        </Button></div>
      </div>       
      {getTabbedHistoryTable(colDefs, notificationLog, "Next Notification", "next-notification")}    
    </>
  );
};

NotificationStep.propTypes = {
  controlNumber: PropTypes.number,
};

export default NotificationStep;